const ROLE_JOIN_LABELS: Record<string, string> = {
  owner: "团队所有者",
  admin: "团队管理员",
  member: "团队成员",
};

export type InviteSharePayload = {
  accountName: string;
  contact: string;
  role: string;
  token: string;
  origin?: string;
};

export function invitationAcceptPath(token: string) {
  return `/invitations/${token}`;
}

export function invitationAcceptUrl(token: string, origin = typeof window !== "undefined" ? window.location.origin : "") {
  return `${origin.replace(/\/$/, "")}${invitationAcceptPath(token)}`;
}

export function invitationJoinLabel(role: string) {
  return ROLE_JOIN_LABELS[role] ?? "团队成员";
}

/** 根据 contact 是否含 @ 判定文案用语：邮箱 / 手机号 */
export function inviteeContactLabel(contact: string): "邮箱" | "手机号" {
  return contact.includes("@") ? "邮箱" : "手机号";
}

/** 一键复制给微信等渠道的邀请说明 + 链接 */
export function buildInvitationShareText({
  accountName,
  contact,
  role,
  token,
  origin,
}: InviteSharePayload) {
  const link = invitationAcceptUrl(token, origin);
  const contactKind = inviteeContactLabel(contact);
  return [
    `【${accountName}】邀请你加入${invitationJoinLabel(role)}`,
    `请使用${contactKind} ${contact} 登录后，打开下方链接接受邀请：`,
    link,
  ].join("\n");
}

export async function copyInvitationShareText(payload: InviteSharePayload) {
  const text = buildInvitationShareText(payload);
  await navigator.clipboard.writeText(text);
  return text;
}
